import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import moment from 'moment';
import { Link } from 'react-router-dom';
import '../../styles/assets.css'
import { utils, write } from 'xlsx';
import { ToastContainer, toast } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';

const AdvanceSalaryRequests = () => {
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [modalData, setModalData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const token = localStorage.getItem("token");
    const handleErrors = useHandleErrors();
    const [loading, setLoading] = useState(false);
    const hasFetchedRef = useRef(false);



    useEffect(() => {
        const fetchAssetReport = async () => {
            setLoading(true)
            try {
                const path = "/getAdvanceSalaryRequests";
                const URL = process.env.REACT_APP_BE_URL + path;
                const response = await axios.get(URL, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                })
                console.log("object", response.data)
                if (response.status === 200) {

                    setData(response.data);
                    setFilteredData(response.data);
                } else {
                    handleErrors(response);
                }
            } catch (error) {
                if (error.response) {
                    if (error.response.status === 404) {
                        // Handle 404 status code separately
                        setData([]);
                        setFilteredData([]);
                    } else {
                        handleErrors(error.response);
                    }
                } else {
                    toast.error("Something went wrong. Please try again later.", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
            } finally {
                setLoading(false);
            }
        }
        if (!hasFetchedRef.current) {
            fetchAssetReport()
            hasFetchedRef.current = true;
        }

    }, []);

    const handleSearch = (event) => {
        const keyword = event.target.value;
        setSearch(keyword);
        if (keyword !== '') {
            const results = data.filter((item) => {
                return item.employeeId?.toLowerCase().includes(keyword?.toLowerCase()) || item.status?.toLowerCase().includes(keyword?.toLowerCase());
            });
            setFilteredData(results);
        } else {
            setFilteredData(data);
        }
    };


    const sendEmail = (email) => {
        // Excel generation logic
        const ws = utils.json_to_sheet(filteredData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Advance Salary Request Report');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

        // Convert the Excel file to a Base64 string
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
            const base64data = reader.result.split(',')[1]; // Get the Base64 string without the prefix

            // Create a downloadable link for the attachment
            const link = document.createElement('a');
            link.href = reader.result;
            link.download = 'Advance Salary Request Report.xlsx';

            // Simulate a click to download the attachment
            link.click();

            // Prepare the mailto link (without attachment)
            const subject = "Advance Salary Request Report";
            const body = 'Please find the attached file.';
            const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

            toast.info('The Excel file has been generated and downloaded. Please attach the file manually to your email.', {
                position: toast.POSITION.TOP_CENTER,
            });

            setTimeout(() => {
                window.location.href = mailtoLink;
            }, 3000);

        };
    };

    const shareData = {
        title: 'Advance Salary Request Report',
        text: 'Check out the Advance Salary Request Report',
        url: window.location.href
    };

    const handleShare = async () => {
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Advance Salary Request Report");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const today = new Date();
        const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
        const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
        const formattedDate = `${year}${month}${day}`;
        saveAs(blob, `WW360-Advance_Salary_Request_Report_${formattedDate}.xlsx`);
    };

    useEffect(() => {
        const preloading = document.getElementById("preloading");
        setTimeout(() => {
            if (preloading) {
                preloading.style.display = "none";
            }
        }, 400);
    }, []);


    const openModal = (item) => {
        setModalData(item);
    };

    const closeModal = () => {
        setModalData(false);
    };
    // pagination
    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(filteredData.length / recordsPerPage);
    const paginate = pageNumber => setCurrentPage(pageNumber);
    // pagination end

    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div className="content-page">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col">
                            <h3 className="title mb-2">Advance Salary Request</h3>
                        </div>
                        <div className="col-auto">
                            <Link to={'/AdvanceSalary'} className="btn btn-primary mt-lg-0 mt-4">
                                <i className="ri-add-circle-line"></i> Register New
                            </Link>
                        </div>
                    </div>
                    {data?.length === 0 ? (
                        <div class="container">
                            <div class="row vh-50 justify-content-center align-items-center">
                                <div class="col-auto">
                                    <div class="no-data-wrapper">
                                        <div class="no-data-found">
                                            <i class="ri-file-damage-fill"></i>
                                            <div class="bounce"><i class="ri-search-eye-line"></i></div>
                                            <p>No Data Found</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div className="row align-items-center justify-content-center mb-4">
                                <div className="col-lg-5 col-md-8 col-sm-10">
                                    <div className="container-fluid row-rounded mb-0">
                                        <div className="row px-2 py-0">
                                            <div className="input-group mb-0">
                                                <input type="search" className="form-control search-input" placeholder="Keyword search..." value={search} onChange={handleSearch} />
                                                <div className="input-group-append">
                                                    <button className="btn btn-primary" type="button" title="Search" onClick={handleSearch}>
                                                        <i className="ri-menu-search-line"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <small className="form-text text-muted text-center mt-0">
                                        <i className="ri-information-2-line"></i> Allows IDs - Employee ID - Status
                                    </small>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="card mb-4">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col">
                                                    <h5 className="title mt-1 mb-0">Summary</h5>
                                                </div>
                                                <div className="col-auto">
                                                    <button
                                                        type="button"
                                                        title="Email"
                                                        rel="tooltip"
                                                        className="btn btn-light btn-circle ml-2"
                                                        onClick={() => sendEmail('')}
                                                    >
                                                        <i className="ri-mail-send-fill"></i>
                                                    </button>
                                                    <button
                                                        type="button"
                                                        title="Share"
                                                        rel="tooltip"
                                                        className="btn btn-light btn-circle ml-2"
                                                        onClick={handleShare}
                                                    >
                                                        <i className="ri-share-fill"></i>
                                                    </button>
                                                    <button type="button" title="Export" className="btn btn-light btn-circle ml-2" onClick={exportToExcel}>
                                                        <i className="ri-export-fill"></i>
                                                    </button>
                                                </div>
                                            </div>
                                            <div className="row mt-3">
                                                <div className="col-md-12">
                                                    <div className="table-responsive asset-information">
                                                        <table className="table grid">
                                                            <thead className="bg-light">
                                                                <tr>
                                                                    <th>S.No.</th>
                                                                    <th>Emp ID  </th>
                                                                    <th>Emp Name  </th>
                                                                    <th>Hr Email </th>
                                                                    <th>Requested Date  </th>
                                                                    <th>Amount </th>
                                                                    <th>Status </th>
                                                                    <th></th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {currentRecords.map((item, index) => (
                                                                    <tr key={index}>
                                                                        <td>{index + 1 + indexOfFirstRecord}</td>
                                                                        <td>{item.employeeId}</td>
                                                                        <td>{item.employeeName}</td>
                                                                        <td>{item.hrEmail}</td>
                                                                        <td>{moment(item.requestedDate).format("DD-MM-YYYY")}</td>
                                                                        <td>
                                                                            {typeof item.amount === 'string' && item.amount.length > 15
                                                                                ? parseFloat(item.amount).toExponential(2) // Adjust the precision as needed
                                                                                : item.amount.toLocaleString()}
                                                                        </td>
                                                                        <td>
                                                                            <span className={`badge border ${item.status.toLowerCase() === 'submitted' ? 'border-secondary text-secondary' : item.status.toLowerCase() === 'approved' ? 'bg-success text-white' : item.status.toLowerCase() === 'rejected' ? 'border-danger text-danger' : item.status.toLowerCase() === 'cancelled' ? 'border-danger text-danger' : item.status.toLowerCase() === 'pending' ? 'border-warning text-warning' : ''} status`}>
                                                                                <i className={`ri-${item.status.toLowerCase() === 'submitted' ? 'thumb-up-fill' : item.status.toLowerCase() === 'approved' ? 'thumb-up-fill' : item.status.toLowerCase() === 'rejected' ? 'thumb-down-fill' : item.status.toLowerCase() === 'cancelled' ? 'close-circle-fill' : item.status.toLowerCase() === 'pending' ? 'hourglass-fill' : ''}`}></i>
                                                                                {` ${item.status}`}
                                                                            </span>
                                                                        </td>
                                                                        <td className="text-center">
                                                                            <button className="btn btn-link text-info btn-action" type="button" title="List View" onClick={() => openModal(item)}>
                                                                                <i className="ri-layout-horizontal-line"></i>
                                                                            </button>
                                                                        </td>
                                                                    </tr>
                                                                ))}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div className="col-md-12">
                                                    <div className="container-fluid">
                                                        <div className="row border-top pt-3">
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Records</p>
                                                            </div>
                                                            <div className="col-1 record-drop">
                                                                <select className="form-control" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                                                    <option value="5">5</option>
                                                                    <option value="10">10</option>
                                                                    <option value="15">15</option>
                                                                    <option value="20">20</option>
                                                                    <option value="25">25</option>
                                                                </select>
                                                            </div>
                                                            <div className="col">
                                                                <nav>
                                                                    <ul className="pagination justify-content-center">
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-double-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage - 1)} tabIndex="-1">
                                                                                <i className="ri-arrow-left-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        {Array.from({ length: totalPages }, (_, index) => (
                                                                            <li key={index + 1} className={`page-item ${index + 1 === currentPage ? 'active' : ''}`}>
                                                                                <button className="page-link" onClick={() => paginate(index + 1)}>
                                                                                    {index + 1}
                                                                                </button>
                                                                            </li>
                                                                        ))}
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                                                                                <i className="ri-arrow-right-s-line"></i>
                                                                            </button>
                                                                        </li>
                                                                        <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                            <button className="page-link" onClick={() => paginate(totalPages)}>
                                                                                <i className="ri-arrow-right-double-fill"></i>
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </nav>
                                                            </div>
                                                            <div className="col-auto">
                                                                <p className="mt-1 mb-0">Page Showing {currentPage} of {totalPages}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            {/* Modal */}
            {
                modalData && (
                    <div className="modal" tabIndex="-1" role="dialog" style={{ display: 'block', textAlign: 'center' }}>
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Request Details</h5>
                                    <button type="button" className="close" onClick={() => setModalData(null)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Employee ID:</span>
                                        <span className="modal-detail-value">{modalData.employeeId}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Employee Name:</span>
                                        <span className="modal-detail-value">{modalData.employeeName}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Employee Email:</span>
                                        <span className="modal-detail-value">{modalData.employeeEmail}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Amount:</span>
                                        <span className="modal-detail-value">
                                            {typeof modalData.amount === 'string' && modalData.amount.length > 15
                                                ? parseFloat(modalData.amount).toExponential(2)
                                                : modalData.amount.toLocaleString()}
                                        </span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Requested Date:</span>
                                        <span className="modal-detail-value">{moment(modalData.requestedDate).format("DD-MM-YYYY")}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Manager Email:</span>
                                        <span className="modal-detail-value">{modalData.hrEmail}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Reason:</span>
                                        <span className="modal-detail-value">{modalData.reason}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Description:</span>
                                        <span className="modal-detail-value">{modalData.description}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Comments:</span>
                                        <span className="modal-detail-value">{modalData.comments}</span>
                                    </div>
                                    <div className="modal-detail-row">
                                        <span className="modal-detail-key">Status:</span>
                                        <span className="modal-detail-value">
                                            <span className={`badge ${modalData.status.toLowerCase() === 'submitted' ? 'border border-secondary text-secondary' : modalData.status.toLowerCase() === 'approved' ? 'bg-success text-white' : modalData.status.toLowerCase() === 'rejected' ? 'border border-danger text-danger' : modalData.status.toLowerCase() === 'cancelled' ? 'border border-danger text-danger' : modalData.status.toLowerCase() === 'pending' ? 'border border-warning text-warning' : ''} status`}>
                                                <i className={`ri-${modalData.status.toLowerCase() === 'submitted' ? 'thumb-up-fill' : modalData.status.toLowerCase() === 'approved' ? 'thumb-up-fill' : modalData.status.toLowerCase() === 'rejected' ? 'thumb-down-fill' : modalData.status.toLowerCase() === 'cancelled' ? 'close-circle-fill' : modalData.status.toLowerCase() === 'pending' ? 'hourglass-fill' : ''}`}></i>
                                                {` ${modalData.status}`}
                                            </span>
                                        </span>
                                    </div>
                                </div>
                                <div className="modal-footer" style={{ display: 'block', textAlign: 'center' }}>
                                    <button type="button" className="btn btn-secondary" onClick={() => setModalData(null)}>Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        </div >
    );

};


export default AdvanceSalaryRequests;
